/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Workflow_Heading2Inputs */

const zh_landing_workflow_heading2 = /** @type {(inputs: Landing_Workflow_Heading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从此化繁为简。`)
};

const en_landing_workflow_heading2 = /** @type {(inputs: Landing_Workflow_Heading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`now simplified.`)
};

const es_landing_workflow_heading2 = /** @type {(inputs: Landing_Workflow_Heading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ahora simplificado.`)
};

/**
* | output |
* | --- |
* | "now simplified." |
*
* @param {Landing_Workflow_Heading2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const landing_workflow_heading2 = /** @type {((inputs?: Landing_Workflow_Heading2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Workflow_Heading2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_landing_workflow_heading2(inputs)
	if (locale === "en") return en_landing_workflow_heading2(inputs)
	return es_landing_workflow_heading2(inputs)
});